import { render, staticRenderFns } from "./as01.vue?vue&type=template&id=9b99671c&scoped=true&"
import script from "./as01.vue?vue&type=script&lang=js&"
export * from "./as01.vue?vue&type=script&lang=js&"
import style0 from "./as01.vue?vue&type=style&index=0&id=9b99671c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b99671c",
  null
  
)

export default component.exports